const admin_url = "https://api.attik.health/api/v1/admin";
// const admin_url ="http://sourmind.alcax.com/api/v1/admin";

const admintoken = JSON.parse(localStorage.getItem("token"));

export { admin_url, admintoken };
